import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { t } from '../utils/translations';

const statusConfig = {
  open: { color: '#F77F00', bg: 'rgba(247,127,0,0.15)' },
  in_progress: { color: '#F77F00', bg: 'rgba(247,127,0,0.15)' },
  resolved: { color: '#22C55E', bg: 'rgba(34,197,94,0.15)' },
  closed: { color: '#6B7280', bg: 'rgba(107,114,128,0.15)' },
};

export function StatusBadge({ status }) {
  const { lang } = useLang();
  const cfg = statusConfig[status] || statusConfig.open;
  return (
    <span data-testid={"status-badge-" + status} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap" style={{ background: cfg.bg, color: cfg.color }}>
      {t(status, lang)}
    </span>
  );
}

export function CategoryBadge({ category }) {
  return (
    <span className="text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap" style={{ color: '#F77F00', background: 'rgba(247,127,0,0.08)' }}>
      {category}
    </span>
  );
}

export function RoleBadge({ role }) {
  const colors = {
    member: { bg: 'rgba(59,130,246,0.15)', color: '#3B82F6' },
    consultant: { bg: 'rgba(168,85,247,0.15)', color: '#A855F7' },
    direction: { bg: 'rgba(247,127,0,0.15)', color: '#F77F00' },
  };
  const cfg = colors[role] || colors.member;
  return (
    <span className="text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap" style={{ background: cfg.bg, color: cfg.color }}>
      {role}
    </span>
  );
}

export function HashtagChip({ tag, onClick }) {
  return (
    <button
      data-testid={"hashtag-" + tag}
      onClick={() => onClick && onClick(tag)}
      className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
      style={{ background: 'rgba(247,127,0,0.12)', color: '#F77F00' }}
    >
      #{tag}
    </button>
  );
}

const visConfig = {
  'private': { color: '#6B7280', bg: 'rgba(107,114,128,0.15)', icon: '\u{1F512}', label_fr: 'Privé', label_en: 'Private' },
  'pending_public': { color: '#F77F00', bg: 'rgba(247,127,0,0.15)', icon: '\u{1F551}', label_fr: 'Validation en cours', label_en: 'Pending' },
  'public': { color: '#22C55E', bg: 'rgba(34,197,94,0.15)', icon: '\u{1F310}', label_fr: 'Public', label_en: 'Public' },
};

export function VisibilityBadge({ visibility, lang }) {
  var cfg = visConfig[visibility] || visConfig['private'];
  return (
    <span data-testid={"visibility-badge-" + visibility} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap" style={{ background: cfg.bg, color: cfg.color }}>
      {lang === 'en' ? cfg.label_en : cfg.label_fr}
    </span>
  );
}
